import CryptoJS from 'crypto-js'
import { saveAs } from 'file-saver'
import { first, last } from 'lodash'
import { DraftAttachment } from '~/types'

const readChunked = (file: File, chunkCallback: CallableFunction, endCallback: CallableFunction) => {
  var fileSize = file.size
  var chunkSize = 4 * 1024 * 1024 // 4MB
  var offset = 0

  var reader = new FileReader()
  reader.onload = () => {
    if (reader.error) {
      endCallback(reader.error || {})
      return
    }
    offset += (reader.result! as string).length
    // callback for handling read chunk
    chunkCallback(reader.result, offset, fileSize)
    if (offset >= fileSize) {
      endCallback(null)
      return
    }
    readNext()
  }

  reader.onerror = err => {
    endCallback(err || {})
  }

  const readNext = () => {
    var fileSlice = file.slice(offset, offset + chunkSize)
    reader.readAsBinaryString(fileSlice)
  }
  readNext()
}

export const calculateMd5Hash = (blob: File, cbProgress?: CallableFunction) => {
  return new Promise((resolve, reject) => {
    var md5 = CryptoJS.algo.MD5.create()
    readChunked(
      blob,
      (chunk: string, offs: number, total: number) => {
        md5.update(CryptoJS.enc.Latin1.parse(chunk))
        if (cbProgress) {
          cbProgress(offs / total)
        }
      },
      (err: any) => {
        if (err) {
          reject(err)
        } else {
          var hash = md5.finalize()
          var hashHex = hash.toString(CryptoJS.enc.Base64)
          resolve(hashHex)
        }
      }
    )
  })
}

interface Attachment {
  fileName: string
  contentType: string
  received: Boolean
  uploadPresignedUrl: string
}

export const uploadFile = async (file: File | null, attachment: DraftAttachment, checksum: string | null = null) => {
  if (!file) return
  if (!checksum) checksum = (await calculateMd5Hash(file)) as string
  const { uploadPresignedUrl, contentType, fileName } = attachment as Attachment
  return fetch(uploadPresignedUrl, {
    headers: {
      'Content-Disposition': `attachment; filename="${fileName}"`,
      'Content-MD5': checksum,
      'Content-Type': contentType
    },
    method: 'PUT',
    body: file
  })
}

/**
 *
 * @param file:File value
 * @param onload:(event:ProgressEvent<FileReader>)=>void) callback function
 *
 */
export const readFileAsText = (file:File, onload:(event:ProgressEvent<FileReader>)=>void) =>{
  const reader = new FileReader()
  reader.readAsText(file)
  reader.addEventListener('load', onload, false)
}

/**
 * @param content:string | ArrayBuffer value
 * @param fileName:string value
 * @param contentType:string optional value
 *
 */
export const writeFile = (content:string | ArrayBuffer, fileName:string, contentType:string='text/plain') =>{
  const blob = new Blob([content], { type : contentType })
   saveAs(blob, fileName)
}

 /**
 *
 * @param filename:string value
 * @returns string value -  "filename"
 */
export const getFileNameWithoutExtension = (filename:string)=>{
return first(filename.split('.'))
}

 /**
 *
 * @param filename:string value
 * @returns string value -  "html"
 */
export const getFileExtension = (filename:string)=>{
  return last(filename.split('.'))
  }


